<script>
export default {
	name: 'TDestinationDotMultiCount',
	functional: true,
	props: {
		count: {
			type: Number,
			default: 0
		}
	},
	render(_, context) {
		if (context.props.count === 0) return null;
		return (
			<svg width="16px" height="13px" viewBox="0 0 16 13" version="1.1" xmlns="http://www.w3.org/2000/svg" {...context.data}>
				<g stroke="none" stroke-width="1" fill="none" fillRule="evenodd">
					<g transform="translate(-34.000000, -63.000000)">
						<g transform="translate(34.000000, 63.000000)">
							<rect fill="#e4e7eb" x="0" y="0" width="16" height="13" rx="6.5"></rect>
							<text font-family="SFProText-Medium, SF Pro Text" font-size="10" font-weight="400" letter-spacing="-0.16" fill="#425A70">
								<tspan x="2.05462891" y="10">{context.props.count}</tspan>
							</text>
						</g>
					</g>
				</g>
			</svg>
		);
	}
};
</script>
